/* eslint-disable array-bracket-newline */
export const proxyAbi = [
  {
    inputs: [
      { internalType: 'address payable', name: 'recepient', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'demandETH',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'contract IERC20', name: 'token', type: 'address' },
      { internalType: 'address', name: 'recepient', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
    ],
    name: 'demandERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;

export const userWalletAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'bytes32',
        name: '_key',
        type: 'bytes32',
      },
      {
        indexed: false,
        internalType: 'bytes32',
        name: '_value',
        type: 'bytes32',
      },
    ],
    name: 'ParamUpdated',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    name: 'params',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_w2w',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_referrer',
        type: 'address',
      },
    ],
    name: 'init',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address payable',
        name: '_recepient',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'demandETH',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: '_token',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_recepient',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'demandERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20[]',
        name: '_tokens',
        type: 'address[]',
      },
      {
        internalType: 'address payable',
        name: '_recepient',
        type: 'address',
      },
    ],
    name: 'demandAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address payable',
        name: '_target',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'demand',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address payable',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_key',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: '_value',
        type: 'bytes32',
      },
    ],
    name: 'changeParam',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newOwner',
        type: 'address',
      },
    ],
    name: 'changeOwner',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;

export const userWalletFactoryAbi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'userWalletPrototype',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'getBytecodeHash',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_user',
        type: 'address',
      },
    ],
    name: 'getUserWallet',
    outputs: [
      {
        internalType: 'contract IUserWallet',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_w2w',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_referrer',
        type: 'address',
      },
    ],
    name: 'deployUserWallet',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
    payable: true,
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_w2w',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_referrer',
        type: 'address',
      },
    ],
    name: 'deployUserWalletFor',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
    payable: true,
  },
] as const;

export const wallet2WalletAbi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_buyBacker',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'contract IUserWallet',
        name: '_user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'contract IERC20',
        name: '_tokenFrom',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amountFrom',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'contract IERC20',
        name: '_tokenTo',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amountTo',
        type: 'uint256',
      },
    ],
    name: 'Copy',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'bytes',
        name: '_error',
        type: 'bytes',
      },
    ],
    name: 'Error',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'contract IUserWallet',
        name: '_user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'contract IERC20',
        name: '_token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: '_referrer',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
    ],
    name: 'ReferralFee',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'previousAdminRole',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'newAdminRole',
        type: 'bytes32',
      },
    ],
    name: 'RoleAdminChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleGranted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleRevoked',
    type: 'event',
  },
  {
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'EXECUTOR_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'EXTRA_GAS',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'GAS_SAVE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'HUNDRED_PERCENT',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'MAX_FEE_PERCENT',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'buyBacker',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address',
      },
    ],
    name: 'fees',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [],
    name: 'gasFeeCollector',
    outputs: [
      {
        internalType: 'address payable',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
    ],
    name: 'getRoleAdmin',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'getRoleMember',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
    ],
    name: 'getRoleMemberCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'hasRole',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
    constant: true,
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
    payable: true,
  },
  {
    inputs: [
      {
        internalType: 'address payable',
        name: '_address',
        type: 'address',
      },
    ],
    name: 'updateGasFeeCollector',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address payable',
        name: '_address',
        type: 'address',
      },
    ],
    name: 'updateBuyBacker',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'contract IUserWallet',
            name: 'user',
            type: 'address',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenFrom',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amountFrom',
            type: 'uint256',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenTo',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'minAmountTo',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'fee',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'referralFee',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'copyToWalletOwner',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'txGasLimit',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'target',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'approveTarget',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes',
          },
          {
            internalType: 'address[]',
            name: 'feeSwapPath',
            type: 'address[]',
          },
          {
            internalType: 'uint256',
            name: 'feeOutMin',
            type: 'uint256',
          },
        ],
        internalType: 'struct Wallet2Wallet.Request',
        name: '_request',
        type: 'tuple',
      },
    ],
    name: 'makeSwap',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
      {
        internalType: 'bytes',
        name: '_reason',
        type: 'bytes',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'contract IUserWallet',
            name: 'user',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amountFrom',
            type: 'uint256',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenTo',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'minAmountTo',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'fee',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'referralFee',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'copyToWalletOwner',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'txGasLimit',
            type: 'uint256',
          },
          {
            internalType: 'address payable',
            name: 'target',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes',
          },
          {
            internalType: 'address[]',
            name: 'feeSwapPath',
            type: 'address[]',
          },
          {
            internalType: 'uint256',
            name: 'feeOutMin',
            type: 'uint256',
          },
        ],
        internalType: 'struct Wallet2Wallet.RequestETHForTokens',
        name: '_request',
        type: 'tuple',
      },
    ],
    name: 'makeSwapETHForTokens',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
      {
        internalType: 'bytes',
        name: '_reason',
        type: 'bytes',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'contract IUserWallet',
            name: 'user',
            type: 'address',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenFrom',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amountFrom',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'minAmountTo',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'fee',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'referralFee',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'copyToWalletOwner',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'txGasLimit',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'target',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'approveTarget',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes',
          },
          {
            internalType: 'address[]',
            name: 'feeSwapPath',
            type: 'address[]',
          },
          {
            internalType: 'uint256',
            name: 'feeOutMin',
            type: 'uint256',
          },
        ],
        internalType: 'struct Wallet2Wallet.RequestTokensForETH',
        name: '_request',
        type: 'tuple',
      },
    ],
    name: 'makeSwapTokensForETH',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
      {
        internalType: 'bytes',
        name: '_reason',
        type: 'bytes',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'contract IUserWallet',
            name: 'user',
            type: 'address',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenFrom',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amountFrom',
            type: 'uint256',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenTo',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'minAmountTo',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'fee',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'referralFee',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'copyToWalletOwner',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'txGasLimit',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'target',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'approveTarget',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes',
          },
          {
            internalType: 'address[]',
            name: 'feeSwapPath',
            type: 'address[]',
          },
          {
            internalType: 'uint256',
            name: 'feeOutMin',
            type: 'uint256',
          },
        ],
        internalType: 'struct Wallet2Wallet.Request',
        name: '_request',
        type: 'tuple',
      },
    ],
    name: '_execute',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'contract IUserWallet',
            name: 'user',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amountFrom',
            type: 'uint256',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenTo',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'minAmountTo',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'fee',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'referralFee',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'copyToWalletOwner',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'txGasLimit',
            type: 'uint256',
          },
          {
            internalType: 'address payable',
            name: 'target',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes',
          },
          {
            internalType: 'address[]',
            name: 'feeSwapPath',
            type: 'address[]',
          },
          {
            internalType: 'uint256',
            name: 'feeOutMin',
            type: 'uint256',
          },
        ],
        internalType: 'struct Wallet2Wallet.RequestETHForTokens',
        name: '_request',
        type: 'tuple',
      },
    ],
    name: '_executeETHForTokens',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'contract IUserWallet',
            name: 'user',
            type: 'address',
          },
          {
            internalType: 'contract IERC20',
            name: 'tokenFrom',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amountFrom',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'minAmountTo',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'fee',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'referralFee',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'copyToWalletOwner',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'txGasLimit',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'target',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'approveTarget',
            type: 'address',
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes',
          },
          {
            internalType: 'address[]',
            name: 'feeSwapPath',
            type: 'address[]',
          },
          {
            internalType: 'uint256',
            name: 'feeOutMin',
            type: 'uint256',
          },
        ],
        internalType: 'struct Wallet2Wallet.RequestTokensForETH',
        name: '_request',
        type: 'tuple',
      },
    ],
    name: '_executeTokensForETH',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20[]',
        name: '_tokens',
        type: 'address[]',
      },
    ],
    name: 'sendFeesToBuyBacker',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IERC20',
        name: '_token',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
    ],
    name: 'collectTokens',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
